import { createSlice } from '@reduxjs/toolkit';
import { RequestStatus } from '../../../../shared/enums/request-status';
import { getAnonymousUserHashRequest, loginRequest } from './extra-actions';

type State = {
  status: RequestStatus;
  message: string;
  error: any;
  token: string | null;
  showError: boolean;
  trackingId: string | null;
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  anonymousUserHashStatus: RequestStatus;
  anonymousUserHashMessage: string;
  anonymousUserHashError: any;
  anonymousUserHash: string | null;
  anonymousUserId: string | null;
};

const initialState: State = {
  status: RequestStatus.Ideal,
  message: '',
  error: '',
  token: '',
  showError: false,
  trackingId: null,
  firstName: null,
  lastName: null,
  email: null,
  anonymousUserHashStatus: RequestStatus.Ideal,
  anonymousUserHashMessage: '',
  anonymousUserHashError: null,
  anonymousUserHash: null,
  anonymousUserId: null,
};

const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    hideError: (state) => {
      state.showError = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loginRequest.pending, (state) => {
      state.status = RequestStatus.Pending;
      state.showError = false;
    });
    builder.addCase(loginRequest.fulfilled, (state, action) => {
      state.status = RequestStatus.Succeeded;
      state.message = action.payload.message;
      state.token = action.payload.payload.accessToken;
      state.trackingId = action.payload.payload.trackingId;
      state.firstName = action.payload.payload.firstName;
      state.lastName = action.payload.payload.lastName;
      state.email = action.payload.payload.email;
    });
    builder.addCase(loginRequest.rejected, (state, action) => {
      state.status = RequestStatus.Failed;
      state.error = action.payload;
      state.showError = !action.payload.isHandled;
    });
    builder.addCase(getAnonymousUserHashRequest.pending, (state) => {
      state.anonymousUserHashStatus = RequestStatus.Pending;
      state.anonymousUserHashError = null;
    });
    builder.addCase(getAnonymousUserHashRequest.fulfilled, (state, action) => {
      state.anonymousUserHashStatus = RequestStatus.Succeeded;
      state.anonymousUserHashMessage = action.payload.message || '';
      state.anonymousUserHash = action.payload.payload?.userHash || null;
      state.anonymousUserId =
        action.payload.payload?.anonymousUserId != null
          ? String(action.payload.payload.anonymousUserId)
          : null;
    });
    builder.addCase(getAnonymousUserHashRequest.rejected, (state, action) => {
      state.anonymousUserHashStatus = RequestStatus.Failed;
      state.anonymousUserHashError = action.payload;
    });
  },
});

export const { hideError } = loginSlice.actions;
export { getAnonymousUserHashRequest, loginRequest };
export default loginSlice.reducer;
